module.exports = __webpack_public_path__ + "assets/img/title-f8946805.png";